import React, { useMemo } from "react"

/**
 * Auth wallpaper — soft cosmic gateway.
 * Geometry only (no text/icons). Calm aurora sheets + orbit rings.
 */
export default function AuthScene({ layerRef }) {
  const orbs = useMemo(
    () => [
      { x: "12%", y: "22%", s: 1.1, d: "0s" },
      { x: "82%", y: "18%", s: 0.75, d: "1.1s" },
      { x: "18%", y: "72%", s: 0.9, d: "0.5s" },
      { x: "78%", y: "68%", s: 1, d: "1.6s" },
      { x: "48%", y: "12%", s: 0.55, d: "0.9s" },
    ],
    []
  )

  return (
    <div
      ref={layerRef}
      className="auth-wallpaper fixed inset-0 pointer-events-none z-[1] overflow-hidden"
      aria-hidden
    >
      <div className="auth-aurora auth-aurora--a" />
      <div className="auth-aurora auth-aurora--b" />
      <div className="auth-aurora auth-aurora--c" />

      <div className="auth-horizon">
        <span className="auth-horizon-band auth-horizon-band--1" />
        <span className="auth-horizon-band auth-horizon-band--2 hidden sm:block" />
        <span className="auth-horizon-band auth-horizon-band--3 hidden md:block" />
      </div>

      <div className="auth-gateway">
        <span className="auth-gateway-ring auth-gateway-ring--outer" />
        <span className="auth-gateway-ring auth-gateway-ring--mid hidden sm:block" />
        <span className="auth-gateway-ring auth-gateway-ring--inner" />
        <span className="auth-gateway-core" />
      </div>

      {orbs.map((o, i) => (
        <span
          key={i}
          className={`auth-orb ${i > 2 ? "hidden md:block" : ""}`}
          style={{
            left: o.x,
            top: o.y,
            "--orb-scale": o.s,
            animationDelay: o.d,
          }}
        />
      ))}

      <span className="auth-spark auth-spark--1" />
      <span className="auth-spark auth-spark--2 hidden sm:block" />
      <span className="auth-spark auth-spark--3 hidden lg:block" />
    </div>
  )
}
